export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  HERES_A_PREVIEW: `Esta es una vista previa de tu audio y video`,
  TURN_OFF_AV_WHILE_WAITING: `Apaga el audio y video mientras esperas`,
  TURN_ON_AV_WHILE_WAITING: `Enciende el audio y video mientras esperas`,
  GOTO_AV_SETTINGS: `Ve a Configuraciones de audio y video`,
  SIT_TIGHT: `Espera, por favor`,
  WE_WILL_CONNECT_AUTOMATICALLY: `
  Te conectaremos automáticamente
  en cuanto estemos listos para ti.`,
  REPORT_TECHNICAL_ISSUE: `Reporta un problema técnico`,
  CAMERA_NOT_SELECTED1: `No has elegido una cámara`,
  CAMERA_NOT_SELECTED2: `Elige una cámara`,
  CAMERA_NOT_FOUND1: `No podemos encontrar una cámara en tu dispositivo`,
  CAMERA_NOT_FOUND2: `Tu llamada será de audio solamente`,
  CAMERA_LOADING: `Cargando la cámara...`,

  WAITING_ROOM_APPT_DETAILS: `Configuración completa.`,
  WAITING_ROOM_APPT_BREATH: `Respira hondo`,
  WAITING_ROOM_INSTRUCTION_1: `Quédate en esta página de la sala de espera.`,
  WAITING_ROOM_INSTRUCTION_2: `Tu llamada comenzará cuando tu equipo de asistencia médica esté listo.`,
  WAITING_ROOM_SIGNPOST_CONNECTIVITY: `Consejo profesional: ¿Tu conexión a Internet es tan potente como podría ser? Si no lo es, acércate a tu enrutador WiFi.`,
  WAITING_ROOM_SIGNPOST_PRIVACY: `Consejo profesional: ¿Estás en un lugar privado? Si no es así, muévete a un lugar donde te sientas cómodo haciendo preguntas sobre tu salud.`,
  WAITING_ROOM_SIGNPOST_STREAMING: `Consejo profesional: ¿Hay alguna otra persona compartiendo tu ancho de banda de Internet? Asegúrate de que nadie esté transmitiendo videos o jugando videojuegos.`,
  WAITING_ROOM_SIGNPOST_UNUSED_TABS: `Consejo profesional: ¿Has cerrado alguna aplicación y pestaña del navegador no utilizadas? Asegúrate de que tu ancho de banda sea lo más potente posible.`,
  WAITING_ROOM_SIGNPOST_DO_NOT_DISTURB: `Consejo profesional: activa la opción "No molestar" en tu equipo durante al menos 1 hora para evitar que se interrumpa si alguien te llama.`,
  WAITING_ROOM_BANNER_HEADER: `Tu equipo de asistencia médica está listo.`,
  WAITING_ROOM_BANNER_CONTENT: `Uniéndote a la llamada...`,
  WAITING_ROOM_CUT_OFF_DETAILS: `<0>Un momento, por favor.</0>
    <1>Te desconectaste</1>`,
  WAITING_ROOM_CUT_OFF_INSTRUCTION: `Permanece en esta página mientras trabajamos para que te unas nuevamente a la llamada.`,
  // NEW TRANSLATIONS
  WAITING_ROOM_WELCOME: `Bienvenido {{patientName}},`,
  WAITING_ROOM_MAIN_TEXT: `Toma un respiro, tu llamada comenzará en breve.`,
  WAITING_ROOM_SUB_TEXT: `Permanece en esta página y la llamada comenzará cuando el equipo médico esté listo.`,

  // TODO: deprecate this key along with WaitingRoomPageV2
  WAITING_ROOM_ONE_WAY_MESSAGE_PROVIDER_DELAYED_TAG: `Disculpa por la demora`,

  // WaitingRoomPageV3 keys
  WAITING_ROOM_STATUS_CONFIRM: `Listo`,
  WAITING_ROOM_STATUS_VISITTIME: `Tu visita comenzará en un momento`,
  WAITING_ROOM_STATUS_WAITTIME: `Tu visita comenzará en un momento`,
  WAITING_ROOM_STATUS_AUTODELAY: `Disculpa por la demora`,
  WAITING_ROOM_STATUS_DELAYED: `Disculpa por la demora`,
  WAITING_ROOM_STATUS_SIT_TIGHT_TITLE: `Espera un momento`,
  WAITING_ROOM_STATUS_SIT_TIGHT_CONTENT: `Tu equipo medico puede ver que estás en línea.`,

  WAITING_ROOM_ONE_WAY_MESSAGE_PROVIDER_DELAYED_HEADER_TEXT: `Tu equipo médico está un poquito atrasado.`,
  WAITING_ROOM_ONE_WAY_MESSAGE_PROVIDER_DELAYED_SUB_TEXT: `Vemos que estás en línea; tu llamada comenzará en cuanto esté listo tu equipo médico.`,
  //Page title
  WAITING_ROOM_TITLE: `Telehealth - Sala de espera`,
};
